import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { useAppDispatch, useAppSelector } from "../../../../lib/redux/hooks"
import { colors } from "../../../../ui/colors"
import { ArrowLeftIcon } from "../../../../ui/icons/arrow-left"
import { Layout } from "../../../../ui/layout"
import { MenuItems } from "../../../../ui/organisms/navbar/dto"
import { RightBar } from "../../../../ui/organisms/rightBar"
import { EntryProtocolValidation, resetEntryProtocolUpdateStatus } from "../slice"
import { EditEntryLeft } from "./editEntryLeft"
import { EditEntryRight } from "./editEntryRight"
import { ButtonComponent } from "../../../../ui/molecules/button/newButton"

export function EditEntryProtocol() {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const entryProtocolState = useAppSelector(state => state.entryProtocol)
    const [showSuccess, setShowSuccess] = useState<boolean>(false)
    const [showUSuccess, setShowUSuccess] = useState<boolean>(false)

    useEffect(() => {
        if (entryProtocolState.entryProtocolUpdateStatus === 'successfully') {
            //dispatch(resetEPFileAndAtt())
            setShowUSuccess(true)
        }
    }, [entryProtocolState.entryProtocolUpdateStatus])

    useEffect(() => {
        if (showUSuccess) {
            setTimeout(() => {
                setShowUSuccess(false)
            }, 2000)
        }
    }, [showUSuccess])

    return (
        <Layout
            menuItem={MenuItems.PROTOCOLLO}
            breadcrumbItems={['Gestione Protocollo', 'Protocollo Entrata', 'Dettaglio']}
            noPaddingLat
            headerLabel="Protocollo Entrata"
            headerIcon={
                <ArrowLeftIcon
                    onClick={() => {
                        dispatch(resetEntryProtocolUpdateStatus())
                        navigate('/entryProtocol')
                    }}
                    color={colors.brandPrimary[50]}
                    size={0}
                />
            }
            headerChildren={
                <div className="flex items-center h-[100%] w-[100%] justify-end gap-2">
                    <ButtonComponent
                        variant='solid'
                        color='orange'
                        size='sm'
                        iconPosition='off'
                        label='Salva protocollo'
                        onClick={() => dispatch(EntryProtocolValidation(entryProtocolState.entryProtocolUpdateRequest))}
                        disabled={
                            entryProtocolState.entryProtocolUpdateStatus === 'loading' ||
                            !entryProtocolState.entryProtocolUpdateRequest.headQuarter ||
                            !entryProtocolState.entryProtocolUpdateRequest.protocolDate ||
                            !entryProtocolState.entryProtocolUpdateRequest.region ||
                            !entryProtocolState.entryProtocolUpdateRequest.sender ||
                            !entryProtocolState.entryProtocolUpdateRequest.entryObjectId ||
                            !entryProtocolState.entryProtocolUpdateRequest.totalPage ||
                            !entryProtocolState.entryProtocolUpdateRequest.entryChannel ||
                            !entryProtocolState.entryProtocolUpdateRequest.send ||
                            entryProtocolState.entryProtocolUpdateRequest.destinationOffice.length === 0
                        } />
                </div>
            }
        >
            <div className="w-full flex-row" style={{ display: 'flex', height: '100%' }}>
                <div className="w-[70%] flex flex-col gap-[16px] filter bg-brandPrimary-200" style={{ padding: '24px 24px 24px 24px', borderTopRightRadius: '20px' }}>
                    {
                        showUSuccess &&
                        <div className="gap-[8px] text-left" style={{ margin: '24px', borderRadius: '12px', backgroundColor: '#D1F5D9', borderColor: '#8AE59F', borderWidth: 2 }}>
                            <span className="text-green-700 fieldsetTitle" style={{ padding: '30px 25px', fontSize: '14px', fontFamily: 'Roboto', fontWeight: '700', display: 'block' }}>
                                Dati salvati correttamente.
                            </span>
                        </div>
                    }
                    <EditEntryLeft />
                </div>
                <div className="w-[30%]">
                    <RightBar>
                        <EditEntryRight />
                    </RightBar>
                </div>
            </div>
        </Layout>
    )
}